import { Box, Button, Typography } from "@mui/material";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./scenarioSetupNewSlice";

export default function Header() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const { editMode } = setupState;

	const handleEditMode = () => {
		dispatch(setState("editMode", !editMode));
		console.log("Scenario Edit Mode", editMode);
	};

	return (
		<Box>
			<Box
				sx={{
               mt: 2,
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					mb: 2,
				}}
			>
				<Box>
					<Typography sx={{mt: 2,}} variant="subtitle1" style={{ color: 'black', fontWeight: 700}} >
						{editMode ? "Search for scenario" : "Define Scenario Parameters"}
					</Typography>
				</Box>
				<Box sx={{}}>
					<Button
						startIcon={editMode ? <NoteAddIcon /> : <ModeEditIcon />}
						sx={{
							bgcolor: "darkBlue.light",
							color: "white.main",
							textTransform: "none",
							"&:hover": {
								bgcolor: "darkBlue.main",
							
							},
						}}
						onClick={handleEditMode}
					>
						<Typography variant="button1" color={"white.main"}>
							{editMode ? "Create New Scenario" : "Edit Scenario"}
						</Typography>
					</Button>
				</Box>
			</Box>
		</Box>
	);
}
